import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import authService from './authService'

// // Get user from localStorage
// const admin = JSON.parse(localStorage.getItem('admin'))

const initialState = {
	admin: null,
	error: false,
	loading: false,
	success: false,
	message: '',
}

// Register Admin
export const register = createAsyncThunk(
	'auth/register',
	async (admin, thunkAPI) => {
		try {
			return await authService.register(admin)
		} catch (error) {
			const message =
				(error.response &&
					error.response.data &&
					error.response.data.message) ||
				error.message ||
				error.toString()
			return thunkAPI.rejectWithValue(message)
		}
	}
)

export const authSlice = createSlice({
	name: 'authRegister',
	initialState,
	reducers: {
		reset: (state) => {
			state.loading = false
			state.success = false
			state.error = false
			state.message = ''
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(register.pending, (state) => {
				state.loading = true
			})
			.addCase(register.fulfilled, (state, action) => {
				state.loading = false
				state.success = true
				state.admin = action.payload
			})
			.addCase(register.rejected, (state, action) => {
				state.loading = false
				state.error = true
				state.message = action.payload
				state.admin = null
			})
	},
})

export const { reset } = authSlice.actions
export default authSlice.reducer
